import 'core-js/fn/object/assign';
import 'core-js/fn/array';
import React from 'react';
import ReacDOM from 'react-dom';
import { createStore, applyMiddleware, compose } from 'redux';
import { Provider } from 'react-redux';
import { addLocaleData, IntlProvider } from 'react-intl';
import en from 'react-intl/locale-data/en';
import zh from 'react-intl/locale-data/zh';
import th from 'react-intl/locale-data/th';
// import sg from 'react-intl/locale-data/sg';
import thunkMiddleware from 'redux-thunk';
import injectTapEventPlugin from 'react-tap-event-plugin';

import { getWebpackHashFromScriptUrl, getUrlParam, isAlipayMiniProgramBrowser } from './helper/common-helper';
import { initSingletonIntl, getShopBaseConf } from './intl/helper';
import PermissionProvider from './permission/PermissionProvider';
import { getPermissions } from './permission/helper';
// import logger from './helper/logger';
import wxminiProgramHelper, { runInRootWhenMiniPrograme } from './helper/wx-miniprogram-helper';
import TopNavigator from './component/common/top-navigator';
import Navigator from './component/common/navigator';
// import initSentry from './helper/sentry';
import './helper/divolte/register-divolte';

const isScanCodeFromConf = getUrlParam('scan'); // 如果页面带入此参数，代表是符合微信扫码活动

window.Intl = require('intl');

injectTapEventPlugin();
// initSentry();

/**
 * 重要提示
 * 此处新增了语言类型，需要在 /src/helper/const/supportLanguage.js 中新增对应的语言类型
 * 同时在 src/helper/const/languages.js 中新增对应的语言资源
 */

addLocaleData([...en, ...zh, ...th]);
addLocaleData({ locale: 'zh_CN', parentLocale: 'zh' });
addLocaleData({ locale: 'en_GB', parentLocale: 'en' });
addLocaleData({ locale: 'zh_TW', parentLocale: 'zh' });
addLocaleData({ locale: 'th_TH', parentLocale: 'th' });

const baseUrl = getWebpackHashFromScriptUrl();

// 装载对应语言包
function loadLanguage(languageDefault) {
  const script = document.createElement('script');
  const current = languageDefault;

  Object.assign(script, {
    type: 'text/javascript',
    src: `${baseUrl}/lang/${current}/index.js`,
  });

  document.body.appendChild(script);

  return new Promise((resolve, reject) => {
    script.onload = function() {
      resolve(this, languageDefault);
    };

    script.onerror = function(error) {
      reject(error);
    };
  });
}

const addReduxDevTools = composeList => {
  if (window.__REDUX_DEVTOOLS_EXTENSION__) {
    composeList.push(window.__REDUX_DEVTOOLS_EXTENSION__());
  }
};

function injectTopNavigator() {
  let div = document.createElement('div');
  document.body.appendChild(div);

  ReacDOM.render(<TopNavigator text="返回" />, div);

  div = null;
}
function topNavigator() {
  if (history.length > 1) {
    const div = document.createElement('div');
    document.body.appendChild(div);
    ReacDOM.render(<Navigator />, div);
  }
}

const createRootApplication = (applicationName, reducer) => {
  // 支付宝平台小程序添加蚂蚁能量 判断条件 1.是支付宝小程序环境下 2.点餐类型type==="TS" 3.在平台版后加fromPlatform==='1'用于区分平台版和模板
  if (isAlipayMiniProgramBrowser() && getUrlParam('type') === 'TS' && getUrlParam('fromPlatform') === '1') {
    localStorage.setItem('antsEnergy', true);
  }
  // 海底捞模板小程序
  if (getUrlParam('wxminiprogramname') === 'h5WxApp' || getUrlParam('hdlScence') === '2') {
    sessionStorage.setItem('ISHDL', '1');
  }
  if (!reducer || typeof reducer !== 'function') {
    ReacDOM.render(applicationName, document.getElementById('app-placeholder'));
    return;
  }

  const composeList = [];

  if (process.env.NODE_ENV !== 'production') {
    // composeList.push(applyMiddleware(thunkMiddleware, logger));
    composeList.push(applyMiddleware(thunkMiddleware));

    addReduxDevTools(composeList);
  } else {
    composeList.push(applyMiddleware(thunkMiddleware));
  }

  const store = compose(...composeList)(createStore)(reducer);

  const render = (messages, languageDefault) => {
    const sessionIsScanCodeFromConf = sessionStorage.isScanCodeFromConf === 'true';
    // 因为原有逻辑判定是否是扫码点餐部分，session中存入isScanCode
    // 此处如果初次进入页面带入的参数&scan=true,session中存入isScanCodeFromConf
    if (isScanCodeFromConf === 'true' && !sessionIsScanCodeFromConf) {
      // 避免频繁写入
      sessionStorage.isScanCodeFromConf = true;
    }
    const intlCfg = { messages, locale: languageDefault };
    const elem = document.getElementById('app-placeholder');
    const rootCls = ` locale--${intlCfg.locale}`.toLocaleLowerCase();

    initSingletonIntl(intlCfg);
    // 切换语言之后，将原来的 ‘local--’删除
    // 因为语言类名肯定在最后，所以采用如下方法
    const localeClassIndex = elem.className.indexOf('locale--');
    if (localeClassIndex !== -1) {
      elem.className = elem.className.slice(0, localeClassIndex);
    }
    elem.className += rootCls; // 将新的语言类名填上
    runInRootWhenMiniPrograme();

    ReacDOM.render(
      <Provider store={store}>
        <IntlProvider {...intlCfg}>
          <PermissionProvider permissions={getPermissions()}>{applicationName}</PermissionProvider>
        </IntlProvider>
      </Provider>,
      elem,
    );

    const {
      type: { topNavSelf },
    } = applicationName;
    if (sessionStorage.getItem('ISHDL') === '1') {
      // 海底捞模板小程序
      topNavigator();
    } else if (wxminiProgramHelper.isMiniProgramMode() && !topNavSelf) {
      injectTopNavigator();
    }
  };

  const loadFunc = languageDefault => {
    loadLanguage(languageDefault)
      .then(() => {
        render(window.__LANG_MESSAGES__, languageDefault);
      })
      .catch(() => {
        render({});
      });
  };
  exports.reload = loadFunc;

  getShopBaseConf(loadFunc, applicationName);
};

export default createRootApplication;



// WEBPACK FOOTER //
// ./src/root-application.js